/**
 * EDF logo mark. Paths taken from the provided Figma SVG.
 * Defaults to the `secondary` token color (#EC842F, the logo color per the
 * design system) via `fill-secondary`, but accepts className so it can be
 * recolored (e.g. on a dark surface) by passing a text/fill utility.
 *
 * Sized by width/height props (defaults 56×21, the SVG's intrinsic ratio).
 */
export type LogoProps = {
  width?: number | string
  height?: number | string
  className?: string
  title?: string
}

export function Logo({ width = 56, height = 21, className, title = 'EDF' }: LogoProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="178 56 56 21"
      fill="none"
      role="img"
      aria-label={title}
      className={`fill-secondary ${className ?? ''}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M178 56H194.317V60.4625H178V56Z" />
      <path d="M210.765 66.5C210.765 63.1656 208.076 60.4625 204.76 60.4625H201.235V72.5375H204.76V77H196.797V56H204.76L204.895 56.0009C210.6 56.0736 215.203 60.7463 215.203 66.5C215.203 72.2537 210.6 76.9264 204.895 76.9991L204.76 77V72.5375C208.076 72.5375 210.765 69.8344 210.765 66.5Z" />
      <path d="M182.177 64.2688H192.228V68.7312H182.177V64.2688Z" />
      <path d="M217.683 56H234V60.4625H217.683V56Z" />
      <path d="M231.911 64.2688V68.7312H222.121V77H217.683V64.2688H231.911Z" />
      <path d="M178 72.5375H194.317V77H178V72.5375Z" />
    </svg>
  )
}